(function () {
  var dragThreshold = 10;
  var clickSuppressionDuration = 500;

  function findActivityNav(sectionId) {
    if (typeof window.getActivityNavBySectionId === 'function') {
      return window.getActivityNavBySectionId(sectionId);
    }

    return window.ActivityNav;
  }

  function scrollToSection(sectionId) {
    var targetSection = document.querySelector('[data-section-id="' + CSS.escape(sectionId) + '"]');
    if (!targetSection) return;

    var activityNav = findActivityNav(sectionId);
    if (activityNav) {
      activityNav.isScrolling = true;
      if (activityNav.scrollTimeout) window.clearTimeout(activityNav.scrollTimeout);
    }

    window.scrollTo({
      top: targetSection.getBoundingClientRect().top + window.pageYOffset - 104,
      behavior: 'smooth',
    });

    if (activityNav) {
      activityNav.scrollTimeout = window.setTimeout(function () {
        activityNav.isScrolling = false;
        activityNav.scrollTimeout = null;
      }, 1000);

      if (typeof activityNav.activateTabBySectionId === 'function') {
        activityNav.activateTabBySectionId(sectionId, false);
      }
    }
  }

  function initBanner(root) {
    if (root.dataset.newDealsBannerInitialized === 'true') return;

    var track = root.querySelector('[data-new-deals-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.new-deals-banner__slide'));
    var indicators = Array.prototype.slice.call(root.querySelectorAll('[data-new-deals-indicator]'));
    var previous = root.querySelector('[data-new-deals-previous]');
    var next = root.querySelector('[data-new-deals-next]');
    if (!track || !slides.length) return;

    root.dataset.newDealsBannerInitialized = 'true';
    var currentIndex = 0;
    var pointerStartX = null;
    var lastDragTime = 0;
    var autoPlayTimer = null;
    var interval = Number(root.dataset.interval) || 5000;
    var autoPlay = root.dataset.autoplay === 'true' && slides.length > 1;

    function render() {
      track.style.transform = 'translate3d(-' + currentIndex * 100 + '%, 0, 0)';
      slides.forEach(function (slide, index) {
        slide.classList.toggle('is-active', index === currentIndex);
      });
      indicators.forEach(function (indicator, index) {
        var isActive = index === currentIndex;
        indicator.classList.toggle('is-active', isActive);
        indicator.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    function goTo(index) {
      currentIndex = (index + slides.length) % slides.length;
      render();
    }

    function restartAutoPlay() {
      if (!autoPlay) return;
      window.clearInterval(autoPlayTimer);
      autoPlayTimer = window.setInterval(function () {
        goTo(currentIndex + 1);
      }, interval);
    }

    function goToAndRestart(index) {
      goTo(index);
      restartAutoPlay();
    }

    if (previous) {
      previous.hidden = slides.length < 2;
      previous.addEventListener('click', function () { goToAndRestart(currentIndex - 1); });
    }
    if (next) {
      next.hidden = slides.length < 2;
      next.addEventListener('click', function () { goToAndRestart(currentIndex + 1); });
    }
    indicators.forEach(function (indicator, index) {
      indicator.addEventListener('click', function () { goToAndRestart(index); });
    });

    track.addEventListener('pointerdown', function (event) {
      if (event.isPrimary) pointerStartX = event.clientX;
    });
    track.addEventListener('pointerup', function (event) {
      if (!event.isPrimary || pointerStartX === null) return;
      var distance = event.clientX - pointerStartX;
      pointerStartX = null;
      if (Math.abs(distance) < dragThreshold) return;
      lastDragTime = Date.now();
      goToAndRestart(distance > 0 ? currentIndex - 1 : currentIndex + 1);
    });
    track.addEventListener('pointercancel', function () { pointerStartX = null; });

    slides.forEach(function (slide) {
      slide.addEventListener('click', function (event) {
        if (Date.now() - lastDragTime < clickSuppressionDuration) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        if (slide.querySelector('.new-deals-banner__link[href]')) return;
        if (slide.dataset.sectionId) scrollToSection(slide.dataset.sectionId);
      });
    });

    render();
    restartAutoPlay();
  }

  function initBanners(scope) {
    (scope || document).querySelectorAll('[data-new-deals-banner]').forEach(initBanner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initBanners(document); });
  } else {
    initBanners(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initBanners(event.target); });
})();
